/**
 * What the run page's Analyst rail sends with every turn (DOP-450).
 *
 * A *descriptor*, never data: only `run_public_id` identifies anything, and
 * the server re-reads that run's ledger owner-scoped at turn time. The labels
 * ride along so the persisted turn is readable on its own — they are never the
 * source of a fact the agent reads.
 */

import type { MonitoringRun } from "../../types/monitoring";

export interface MonitoringContext {
	kind: "monitoring_run";
	run_public_id: string;
	template: string;
	borrower: string;
	period: string;
	/** The figure row the user has open, so "this figure" means one of them. */
	selected_figure: string | null;
	/** The run page tab the question was asked from, so the thread reopens there (DOP-470). */
	tab: string | null;
}

export interface MonitoringContextInput {
	run: MonitoringRun;
	/** The figure key the user has expanded, when one is. */
	selectedFigureKey?: string | null;
	/** The tab on screen when the question is sent. */
	tab?: string | null;
}

export function buildMonitoringContext({
	run,
	selectedFigureKey = null,
	tab = null,
}: MonitoringContextInput): MonitoringContext {
	return {
		kind: "monitoring_run",
		run_public_id: run.public_id,
		template: run.template.name,
		borrower: run.borrower.name,
		period: run.period.label,
		selected_figure: selectedFigureKey,
		tab,
	};
}

/** The rail's context chip: what "this" means in every question sent. */
export function monitoringChipLabel(run: MonitoringRun): string {
	return `${run.borrower.name} · ${run.period.label} · ${run.status}`;
}
